/* Nitrous Outlet master fitment data
   Engine values are filled where the application is confidently engine-specific.
   Blank engine rows are intentionally engine-independent accessories/body fitment.
*/

window.NO_FITMENT_DATA = [

  {"yearStart":2016,"yearEnd":2019,"make":"Cadillac","model":"CTS-V","engine":"","submodel":"","productIds":["7278598914188","7278611366028"]},
  {"yearStart":2016,"yearEnd":2019,"make":"Cadillac","model":"CTS-V","engine":"6.2L LT4","submodel":"","productIds":["7278611562636"]},
  {"yearStart":2016,"yearEnd":2019,"make":"Cadillac","model":"CTS-V","engine":"6.2L LT4","submodel":"103mm throttle body","productIds":["7278614708364"]},
  {"yearStart":2015,"yearEnd":2019,"make":"Cadillac","model":"CTS-V","engine":"","submodel":"","productIds":["7278611333260"]},
  {"yearStart":2009,"yearEnd":2014,"make":"Cadillac","model":"CTS-V","engine":"6.2L LSA","submodel":"90mm throttle body","productIds":["7278610055308","7278598717580"]},
  {"yearStart":2009,"yearEnd":2014,"make":"Cadillac","model":"CTS-V","engine":"","submodel":"","productIds":["7278598783116"]},

  {"yearStart":2017,"yearEnd":2021,"make":"Chevrolet","model":"Camaro","engine":"6.2L LT4","submodel":"ZL1","productIds":["7278611562636","7278611726476"]},
  {"yearStart":2017,"yearEnd":2021,"make":"Chevrolet","model":"Camaro","engine":"6.2L LT4","submodel":"ZL1 • 103mm throttle body","productIds":["7278614708364","7278614741132"]},
  {"yearStart":2016,"yearEnd":2021,"make":"Chevrolet","model":"Camaro","engine":"","submodel":"","productIds":["7278611693708","7278611660940","7278611595404","7278611628172","7468834455692"]},
  {"yearStart":2016,"yearEnd":2019,"make":"Chevrolet","model":"Camaro","engine":"6.2L LT1","submodel":"","productIds":["7278611431564"]},
  {"yearStart":2016,"yearEnd":2019,"make":"Chevrolet","model":"Camaro","engine":"6.2L LT1","submodel":"SS • MSD Atomic AirForce intake","productIds":["7278611529868"]},

  {"yearStart":2012,"yearEnd":2015,"make":"Chevrolet","model":"Camaro","engine":"6.2L LSA","submodel":"ZL1","productIds":["7278610579596","7278610415756","7278610448524","7278610612364","7278610514060"]},
  {"yearStart":2012,"yearEnd":2015,"make":"Chevrolet","model":"Camaro","engine":"6.2L LSA","submodel":"ZL1 • 90mm throttle body","productIds":["7278610546828"]},

  {"yearStart":2010,"yearEnd":2015,"make":"Chevrolet","model":"Camaro","engine":"","submodel":"","productIds":["7278610219148","7278610120844","7278610153612","7278615494796"]},
  {"yearStart":2010,"yearEnd":2015,"make":"Chevrolet","model":"Camaro","engine":"6.2L LS3 / L99","submodel":"SS • FAST 102mm intake","productIds":["7278608121996"]},
  {"yearStart":2010,"yearEnd":2015,"make":"Chevrolet","model":"Camaro","engine":"6.2L LS3 / L99","submodel":"SS • 90mm throttle body","productIds":["7278612807820","7278612840588"]},
  {"yearStart":2010,"yearEnd":2015,"make":"Chevrolet","model":"Camaro","engine":"3.6L V6","submodel":"V6","productIds":["7278610284684"]},
  {"yearStart":2010,"yearEnd":2020,"make":"Chevrolet","model":"Camaro","engine":"3.6L V6","submodel":"V6","productIds":["7278610350220","7278627881100"]},

  {"yearStart":1998,"yearEnd":2002,"make":"Chevrolet","model":"Camaro","engine":"5.7L LS1","submodel":"","productIds":["7278615232652"]},
  {"yearStart":1993,"yearEnd":1997,"make":"Chevrolet","model":"Camaro","engine":"","submodel":"Automatic","productIds":["7278608744588"]},
  {"yearStart":1983,"yearEnd":1992,"make":"Chevrolet","model":"Camaro","engine":"","submodel":"","productIds":["7278614904972"]},


  {"yearStart":2023,"yearEnd":2026,"make":"Chevrolet","model":"Corvette","engine":"5.5L LT6","submodel":"Z06 • Dual 87mm throttle body","productIds":["9519069560972","9534333550732"]},

  {"yearStart":2019,"yearEnd":2019,"make":"Chevrolet","model":"Corvette","engine":"6.2L LT5","submodel":"ZR1","productIds":["7278611792012","7278611824780","7278611857548","7278611759244"]},

  {"yearStart":2015,"yearEnd":2019,"make":"Chevrolet","model":"Corvette","engine":"6.2L LT4","submodel":"Z06 • 83mm throttle body","productIds":["7278611202188","7278611234956","7278611267724"]},
  {"yearStart":2015,"yearEnd":2019,"make":"Chevrolet","model":"Corvette","engine":"6.2L LT4","submodel":"Z06","productIds":["7278611300492"]},
  {"yearStart":2015,"yearEnd":2019,"make":"Chevrolet","model":"Corvette","engine":"6.2L LT4","submodel":"Z06 • 103mm throttle body","productIds":["7278614577292","7278614610060","7278614642828"]},

  {"yearStart":2014,"yearEnd":2019,"make":"Chevrolet","model":"Corvette","engine":"","submodel":"","productIds":["7278611038348","7278610940044","7278610972812","7278611005580","7278611071116","7468831867020"]},
  {"yearStart":2014,"yearEnd":2019,"make":"Chevrolet","model":"Corvette","engine":"6.2L LT1","submodel":"","productIds":["7278611136652","7278611103884"]},
  {"yearStart":2014,"yearEnd":2019,"make":"Chevrolet","model":"Corvette","engine":"6.2L LT1","submodel":"90mm throttle body","productIds":["7278610546828"]},
  {"yearStart":2020,"yearEnd":2021,"make":"Chevrolet","model":"Corvette","engine":"6.2L LT2","submodel":"90mm throttle body","productIds":["7278610546828"]},

  {"yearStart":2008,"yearEnd":2013,"make":"Chevrolet","model":"Corvette","engine":"6.2L LS3","submodel":"90mm throttle body","productIds":["7278612775052","7278612742284"]},
  {"yearStart":2008,"yearEnd":2013,"make":"Chevrolet","model":"Corvette","engine":"","submodel":"","productIds":["7468838387852"]},

  {"yearStart":2005,"yearEnd":2007,"make":"Chevrolet","model":"Corvette","engine":"6.0L LS2","submodel":"90mm throttle body","productIds":["7278612578444"]},
  {"yearStart":2005,"yearEnd":2013,"make":"Chevrolet","model":"Corvette","engine":"","submodel":"","productIds":["7278609793164","7278609760396","7278609727628","7278609825932"]},

  {"yearStart":2005,"yearEnd":2007,"make":"Chevrolet","model":"Corvette","engine":"6.0L LS2","submodel":"92mm intake","productIds":["7278613233804"]},
  {"yearStart":2008,"yearEnd":2009,"make":"Chevrolet","model":"Corvette","engine":"6.2L LS3","submodel":"92mm intake","productIds":["7278613233804"]},

  {"yearStart":2006,"yearEnd":2013,"make":"Chevrolet","model":"Corvette","engine":"7.0L LS7","submodel":"Z06 • 90mm throttle body","productIds":["7278612643980"]},

  {"yearStart":1997,"yearEnd":2004,"make":"Chevrolet","model":"Corvette","engine":"","submodel":"","productIds":["7278608777356","7278608941196","7278608908428","7491169747084","7278615462028","7278615429260","7278608875660"]},
  {"yearStart":1997,"yearEnd":2004,"make":"Chevrolet","model":"Corvette","engine":"5.7L LS1 / LS6","submodel":"78mm throttle body","productIds":["7278612349068"]},
  {"yearStart":1997,"yearEnd":2004,"make":"Chevrolet","model":"Corvette","engine":"5.7L LS1 / LS6","submodel":"FAST 90mm intake","productIds":["7278612938892"]},
  {"yearStart":1997,"yearEnd":2004,"make":"Chevrolet","model":"Corvette","engine":"5.7L LS1 / LS6","submodel":"FAST 92mm intake","productIds":["7278613201036"]},
  {"yearStart":1997,"yearEnd":2013,"make":"Chevrolet","model":"Corvette","engine":"","submodel":"","productIds":["7278609039500","7278609072268","7278609105036"]},


  {"yearStart":2007,"yearEnd":2014,"make":"Chevrolet","model":"Silverado","engine":"","submodel":"","productIds":["7278577778828","7278609957004"]},


  {"yearStart":2007,"yearEnd":2013,"make":"Chevrolet","model":"Trailblazer","engine":"6.0L LS2","submodel":"SS • 90mm throttle body","productIds":["7278612709516"]},
  {"yearStart":2006,"yearEnd":2009,"make":"Chevrolet","model":"Trailblazer","engine":"","submodel":"SS","productIds":["7278609891468"]},
  {"yearStart":2005,"yearEnd":2009,"make":"Chevrolet","model":"Trailblazer","engine":"","submodel":"SS","productIds":["7278609694860"]},


  {"yearStart":2005,"yearEnd":2011,"make":"Chrysler","model":"300 / 300C","engine":"","submodel":"","productIds":["7278600388748"]},

  {"yearStart":2009,"yearEnd":2019,"make":"Chrysler","model":"300 / 300C","engine":"5.7L HEMI","submodel":"80mm throttle body","productIds":["7278601502860"]},
  {"yearStart":2009,"yearEnd":2019,"make":"Chrysler","model":"300 / 300C","engine":"5.7L HEMI","submodel":"85mm throttle body","productIds":["7278601633932"]},
  {"yearStart":2009,"yearEnd":2019,"make":"Chrysler","model":"300 / 300C","engine":"5.7L HEMI","submodel":"90mm throttle body","productIds":["7278601765004"]},


  {"yearStart":2015,"yearEnd":2023,"make":"Dodge","model":"Challenger","engine":"","submodel":"Automatic","productIds":["7278601306252"]},

  {"yearStart":2015,"yearEnd":2023,"make":"Dodge","model":"Challenger","engine":"6.2L Supercharged HEMI","submodel":"Hellcat • Automatic","productIds":["9379565174924"]},

  {"yearStart":2015,"yearEnd":2023,"make":"Dodge","model":"Challenger","engine":"6.2L Supercharged HEMI","submodel":"Hellcat / Redeye • Whipple 3.0/3.8","productIds":["7278601240716","7278601273484"]},

  {"yearStart":2015,"yearEnd":2023,"make":"Dodge","model":"Challenger","engine":"6.2L Supercharged HEMI","submodel":"Hellcat / Redeye","productIds":["7278601142412"]},

  {"yearStart":2015,"yearEnd":2019,"make":"Dodge","model":"Challenger","engine":"","submodel":"","productIds":["7278600847500"]},

  {"yearStart":2009,"yearEnd":2019,"make":"Dodge","model":"Challenger","engine":"5.7L HEMI","submodel":"80mm throttle body","productIds":["7278601502860"]},
  {"yearStart":2009,"yearEnd":2019,"make":"Dodge","model":"Challenger","engine":"5.7L HEMI","submodel":"85mm throttle body","productIds":["7278601633932"]},
  {"yearStart":2009,"yearEnd":2019,"make":"Dodge","model":"Challenger","engine":"5.7L HEMI","submodel":"90mm throttle body","productIds":["7278601765004"]},


  {"yearStart":2015,"yearEnd":2023,"make":"Dodge","model":"Charger","engine":"6.2L Supercharged HEMI","submodel":"Hellcat / Redeye • Whipple 3.0/3.8","productIds":["7278601240716","7278601273484"]},

  {"yearStart":2015,"yearEnd":2023,"make":"Dodge","model":"Charger","engine":"6.2L Supercharged HEMI","submodel":"Hellcat / Redeye","productIds":["7278601142412"]},

  {"yearStart":2015,"yearEnd":2019,"make":"Dodge","model":"Charger","engine":"","submodel":"","productIds":["7278600847500","9379527721100"]},

  {"yearStart":2009,"yearEnd":2019,"make":"Dodge","model":"Charger","engine":"5.7L HEMI","submodel":"80mm throttle body","productIds":["7278601502860"]},
  {"yearStart":2009,"yearEnd":2019,"make":"Dodge","model":"Charger","engine":"5.7L HEMI","submodel":"85mm throttle body","productIds":["7278601633932"]},
  {"yearStart":2009,"yearEnd":2019,"make":"Dodge","model":"Charger","engine":"5.7L HEMI","submodel":"90mm throttle body","productIds":["7278601765004"]},

  {"yearStart":2005,"yearEnd":2011,"make":"Dodge","model":"Charger","engine":"","submodel":"","productIds":["7278600388748"]},


  {"yearStart":2005,"yearEnd":2011,"make":"Dodge","model":"Magnum","engine":"","submodel":"","productIds":["7278600388748"]},

  {"yearStart":2005,"yearEnd":2008,"make":"Dodge","model":"Magnum","engine":"5.7L HEMI","submodel":"80mm throttle body","productIds":["7278601502860"]},
  {"yearStart":2005,"yearEnd":2008,"make":"Dodge","model":"Magnum","engine":"5.7L HEMI","submodel":"85mm throttle body","productIds":["7278601633932"]},
  {"yearStart":2005,"yearEnd":2008,"make":"Dodge","model":"Magnum","engine":"5.7L HEMI","submodel":"90mm throttle body","productIds":["7278601765004"]},


  {"yearStart":2014,"yearEnd":2017,"make":"Dodge","model":"Viper","engine":"8.4L V10","submodel":"","productIds":["7468831834252"]},
  {"yearStart":1992,"yearEnd":2002,"make":"Dodge","model":"Viper","engine":"8.0L V10","submodel":"","productIds":["7278600126604","7278600061068"]},


  {"yearStart":2018,"yearEnd":2023,"make":"Ford","model":"F-150","engine":"","submodel":"","productIds":["8113700601996"]},

  {"yearStart":2018,"yearEnd":2024,"make":"Ford","model":"F-150","engine":"5.0L Coyote","submodel":"","productIds":["8111508816012","8113682415756"]},

  {"yearStart":2011,"yearEnd":2017,"make":"Ford","model":"F-150","engine":"5.0L Coyote","submodel":"","productIds":["7278606712972","7278606647436","7278606680204"]},

  {"yearStart":1999,"yearEnd":2004,"make":"Ford","model":"F-150 Lightning","engine":"5.4L Supercharged V8","submodel":"","productIds":["7278605926540","7278627717260"]},


  {"yearStart":2024,"yearEnd":2026,"make":"Ford","model":"Mustang","engine":"5.0L Coyote Gen 4","submodel":"GT","productIds":["8413324542092","8414443077772","8414385111180"]},

  {"yearStart":2018,"yearEnd":2020,"make":"Ford","model":"Mustang","engine":"5.0L Coyote Gen 3","submodel":"GT","productIds":["7278607171724"]},

  {"yearStart":2018,"yearEnd":2020,"make":"Ford","model":"Mustang","engine":"","submodel":"","productIds":["7278607237260"]},

  {"yearStart":2015,"yearEnd":2020,"make":"Ford","model":"Mustang","engine":"2.3L EcoBoost","submodel":"EcoBoost","productIds":["7278606876812","7278606909580","7278606844044","7278606942348"]},

  {"yearStart":2011,"yearEnd":2017,"make":"Ford","model":"Mustang","engine":"5.0L Coyote","submodel":"GT • 80mm throttle body","productIds":["7383866179724"]},

  {"yearStart":2011,"yearEnd":2017,"make":"Ford","model":"Mustang","engine":"5.0L Coyote","submodel":"GT","productIds":["7278606647436","7278606680204","7278606581900"]},

  {"yearStart":2015,"yearEnd":2017,"make":"Ford","model":"Mustang","engine":"5.2L Voodoo","submodel":"GT350 / GT350R","productIds":["7278606581900"]},

  {"yearStart":2011,"yearEnd":2014,"make":"Ford","model":"Mustang","engine":"","submodel":"","productIds":["7278606516364"]},

  {"yearStart":2011,"yearEnd":2017,"make":"Ford","model":"Mustang","engine":"5.0L Coyote","submodel":"","productIds":["7278606712972"]},

  {"yearStart":2011,"yearEnd":2019,"make":"Ford","model":"Mustang","engine":"5.0L Coyote","submodel":"Cobra Jet intake","productIds":["7278606778508"]},

  {"yearStart":2007,"yearEnd":2012,"make":"Ford","model":"Mustang","engine":"5.4L Supercharged V8","submodel":"GT500","productIds":["7278606254220","7278606352524","7278606418060","7278606319756","7278606286988"]},

  {"yearStart":2013,"yearEnd":2014,"make":"Ford","model":"Mustang","engine":"5.8L Supercharged V8","submodel":"GT500","productIds":["7278606254220","7278606352524","7278606418060","7278606319756","7278606286988"]},

  {"yearStart":2005,"yearEnd":2010,"make":"Ford","model":"Mustang","engine":"4.6L 3V","submodel":"GT","productIds":["7278605992076","7278606090380","7278606123148","7278606024844","7278606057612","7278605959308","7278627815564"]},

  {"yearStart":2005,"yearEnd":2014,"make":"Ford","model":"Mustang","engine":"","submodel":"","productIds":["7278606155916","7278606188684","7278606221452"]},

  {"yearStart":1999,"yearEnd":2001,"make":"Ford","model":"Mustang","engine":"4.6L 4V","submodel":"Cobra","productIds":["7278605762700","7278605795468","7278605861004","7278605828236"]},

  {"yearStart":2003,"yearEnd":2004,"make":"Ford","model":"Mustang","engine":"4.6L 4V","submodel":"Mach 1","productIds":["7278605795468","7278605861004"]},

  {"yearStart":1999,"yearEnd":2004,"make":"Ford","model":"Mustang","engine":"","submodel":"Mach 1 / Cobra / GT","productIds":["7278627782796"]},

  {"yearStart":1999,"yearEnd":2004,"make":"Ford","model":"Mustang","engine":"","submodel":"","productIds":["7278605926540"]},

  {"yearStart":1998,"yearEnd":2004,"make":"Ford","model":"Mustang","engine":"","submodel":"","productIds":["7278605729932"]},

  {"yearStart":1996,"yearEnd":2004,"make":"Ford","model":"Mustang","engine":"4.6L 2V","submodel":"GT","productIds":["7278605631628","7278605664396"]},

  {"yearStart":1996,"yearEnd":2004,"make":"Ford","model":"Mustang","engine":"","submodel":"","productIds":["7278605697164"]},

  {"yearStart":1994,"yearEnd":1997,"make":"Ford","model":"Mustang","engine":"","submodel":"","productIds":["7278605598860"]},

  {"yearStart":1987,"yearEnd":1998,"make":"Ford","model":"Mustang","engine":"","submodel":"Cobra / GT","productIds":["7278627684492"]},

  {"yearStart":1987,"yearEnd":2004,"make":"Ford","model":"Mustang","engine":"","submodel":"GT","productIds":["7278605566092"]},

  {"yearStart":1987,"yearEnd":1993,"make":"Ford","model":"Mustang","engine":"","submodel":"","productIds":["7278605500556"]},

  {"yearStart":1987,"yearEnd":1998,"make":"Ford","model":"Mustang","engine":"","submodel":"","productIds":["7278605533324"]},

  {"yearStart":1979,"yearEnd":1986,"make":"Ford","model":"Mustang","engine":"","submodel":"","productIds":["7278605435020"]},


  {"yearStart":2007,"yearEnd":2014,"make":"GMC","model":"Sierra","engine":"","submodel":"","productIds":["7278577778828","7278609957004"]},


  {"yearStart":2018,"yearEnd":2021,"make":"Jeep","model":"Grand Cherokee / Trackhawk","engine":"6.2L Supercharged HEMI","submodel":"Trackhawk","productIds":["7278601044108","7278601142412"]},

  {"yearStart":2018,"yearEnd":2021,"make":"Jeep","model":"Grand Cherokee / Trackhawk","engine":"6.2L Supercharged HEMI","submodel":"Trackhawk • Whipple 3.0/3.8","productIds":["7278601240716","7278601273484"]},


  {"yearStart":1998,"yearEnd":2002,"make":"Pontiac","model":"Firebird / Trans Am","engine":"5.7L LS1","submodel":"","productIds":["7278615232652"]},


  {"yearStart":2005,"yearEnd":2006,"make":"Pontiac","model":"GTO","engine":"6.0L LS2","submodel":"90mm throttle body","productIds":["7278618902668"]},

  {"yearStart":2005,"yearEnd":2006,"make":"Pontiac","model":"GTO","engine":"","submodel":"","productIds":["7278618771596"]},

  {"yearStart":2004,"yearEnd":2006,"make":"Pontiac","model":"GTO","engine":"","submodel":"","productIds":["7278615462028","7278618673292","7278615429260","7278618607756","7278618706060","7278609039500","7278618640524","7278618574988"]},

  {"yearStart":2004,"yearEnd":2006,"make":"Pontiac","model":"GTO","engine":"5.7L LS1 / 6.0L LS2","submodel":"FAST 90mm intake","productIds":["7278618968204"]},

  {"yearStart":2004,"yearEnd":2006,"make":"Pontiac","model":"GTO","engine":"5.7L LS1 / 6.0L LS2","submodel":"FAST 92mm intake","productIds":["7278619033740"]},

  {"yearStart":2004,"yearEnd":2004,"make":"Pontiac","model":"GTO","engine":"5.7L LS1","submodel":"78mm throttle body","productIds":["7278618837132"]}

];


/* =========================================================
   TRUE UNIVERSAL PRODUCTS
   ========================================================= */

window.NO_UNIVERSAL_FIT_IDS = [

  "7316045955212",
  "7278598324364",
  "7491161653388",
  "7278599831692",
  "7278625554572",
  "7278625652876",
  "7491159359628",
  "7491159294092",
  "7491159228556",
  "7491159163020",
  "7491159326860",
  "7491159261324",
  "7491159195788",
  "7491159130252",
  "8324077224076",
  "7278624931980",
  "7468831539340",
  "7278624997516",
  "9243915452556",
  "7278618542220",
  "7573230387340",
  "7744961314956",
  "7278577680524",
  "7278624964748",
  "7278625030284",
  "7278615396492",
  "7491160539276",
  "7491160473740",
  "7712724123788",
  "7563975721100",
  "7278618509452",
  "7278625620108",
  "7278625587340",
  "7278625685644",
  "7278625718412",
  "7278628536460",
  "7278628569228",
  "7278587478156",
  "7278590165132",
  "8316895428748",
  "7278597767308",
  "7278597800076",
  "7278597439628",
  "7278597505164",
  "7278597472396",
  "7278597537932",
  "7278605140108"

];


/* =========================================================
   UNIVERSAL / SETUP-DEPENDENT
   ========================================================= */

window.NO_UNIVERSAL_APPLICATIONS = {

  "7278611169420":
    "2014+ GM application — verify vehicle fuel and EFI requirements.",

  "8949825962124":
    "Requires a 2020–2026 Ford 7.3L Godzilla OEM throttle-body application.",

  "7278625063052":
    "Universal 5/16-inch fuel-line application — verify line size before ordering.",

  "7278625194124":
    "Universal intake/filter application — verify filter style and dimensions.",

  "7278625095820":
    "Universal for diesel vehicles — diesel application required.",

  "7278625226892":
    "Universal dry-system application — verify engine-management and fueling requirements.",

  "7278625128588":
    "Universal for diesel vehicles — diesel application required.",

  "7278625423500":
    "Universal dry-system application — verify engine-management and fueling requirements.",

  "7278625357964":
    "Universal late-model EFI application — verify fuel-pressure and nozzle requirements.",

  "7278625390732":
    "Universal late-model EFI application — verify fuel-pressure and nozzle requirements.",

  "7278625456268":
    "Universal late-model EFI application — verify fuel-pressure and nozzle requirements.",

  "7278625489036":
    "Universal late-model EFI application — verify fuel-pressure and nozzle requirements.",

  "7278625521804":
    "Universal late-model EFI application — verify fuel-pressure and nozzle requirements.",

  "7491167813772":
    "Universal in-tank fuel-system application — verify pump, fuel, and tank compatibility.",

  "7278625161356":
    "Universal intake/filter application — verify filter style and dimensions.",

  "7278625292428":
    "Universal dry-system application — verify engine-management and fueling requirements.",

  "7278625325196":
    "Universal dry-system application — verify engine-management and fueling requirements.",

  "7278628372620":
    "Universal late-model EFI application — verify fuel-pressure and nozzle requirements.",

  "7278628470924":
    "Universal late-model EFI application — verify fuel-pressure and nozzle requirements.",

  "7278628405388":
    "Universal late-model EFI application — verify fuel-pressure and nozzle requirements.",

  "7278616641676":
    "Universal turbocharged application — verify charge-pipe size and wet/dry setup.",

  "7278616674444":
    "Universal turbocharged application — verify charge-pipe size and wet/dry setup."

};